import React from 'react';

const MemioLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { icon: 24, text: 'text-lg' },
    md: { icon: 32, text: 'text-xl' },
    lg: { icon: 40, text: 'text-2xl' },
    xl: { icon: 48, text: 'text-3xl' }
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Logo Icon - Envelope with memory sparkle */}
      <div className="relative">
        <svg
          width={icon}
          height={icon}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-sm"
        >
          {/* Envelope body */}
          <rect
            x="4"
            y="12"
            width="40"
            height="28"
            rx="4"
            fill="#FDFBF7"
            stroke="#8D6E63"
            strokeWidth="2.5"
          />
          {/* Envelope flap */}
          <path
            d="M4 16L24 28L44 16"
            stroke="#8D6E63"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Inner fold line */}
          <path
            d="M4 40L18 28M44 40L30 28"
            stroke="#D4A373"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.6"
          />
          {/* Memory sparkle/star */}
          <circle cx="38" cy="10" r="6" fill="#D4A373" />
          <path
            d="M38 6V14M34 10H42"
            stroke="#FDFBF7"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* Small sparkles */}
          <circle cx="8" cy="8" r="2" fill="#D4A373" opacity="0.6" />
          <circle cx="14" cy="5" r="1.5" fill="#8D6E63" opacity="0.4" />
        </svg>
      </div>
      
      {/* Logo Text */}
      {showText && (
        <span className={`font-serif font-semibold ${text} text-[#4A4A4A]`}>
          Mem<span className="text-[#D4A373]">io</span>
        </span>
      )}
    </div>
  );
};

export default MemioLogo;
